module.exports = __webpack_public_path__ + "img/collection-memoireRingsRosegold.d0e2132.jpg";